module.exports = __webpack_public_path__ + "static/kongo_image_1-073538f3be2931b5851735d0cebf09b6.jpg";